export default "__VITE_ASSET__C6saP7rd__"